import { render } from "./socials.vue?vue&type=template&id=1f53f19b&ts=true"
import script from "./socials.vue?vue&type=script&lang=ts"
export * from "./socials.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__